import React, { Component } from 'react';
import { Route, Switch } from 'react-router-dom';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { fade } from 'material-ui/utils/colorManipulator';
import { ThemeProvider } from 'styled-components';
import {
  deepPurple500, deepPurple700,
  redA200,
  grey100, grey200, grey300, grey400, grey500,
  white, darkBlack, fullBlack,
} from 'material-ui/styles/colors';
import NotFound from './views/NotFound';
import InvalidDrive from './views/InvalidDrive';
// import CorporateForm from './views/CorporateForm';
// import CorporateShortForm from './views/CorporateShortForm';
// import CollegeForm from './views/CollegeForm';
// import CandidateForm from './views/CandidateForm';
import CampaignForm from './views/CampaignForm';


const theme = {
  primary1Color: deepPurple500,
  primary2Color: deepPurple700,
  primary3Color: grey400,
  accent1Color: redA200,
  accent2Color: grey100,
  accent3Color: grey500,
  textColor: darkBlack,
  alternateTextColor: white,
  canvasColor: white,
  borderColor: grey300,
  disabledColor: fade(darkBlack, 0.3),
  pickerHeaderColor: deepPurple500,
  clockCircleColor: fade(darkBlack, 0.07),
  shadowColor: fullBlack,
  backgroundColor: grey200,
};

const muiTheme = getMuiTheme({
  palette: theme,
});


class App extends Component {
  render() {
    return (
      <ThemeProvider theme={theme}>
        <MuiThemeProvider muiTheme={muiTheme}>
          <Switch>
            <Route path="/invalid" component={InvalidDrive} />
            {/* <Route path="/corporate" component={CorporateForm} />
            <Route path="/register" component={CorporateShortForm} />
            <Route path="/college" component={CollegeForm} />
            <Route path="/candidate/:id" render={({ match, history }) => (
              <CandidateForm match={match} history={history} />
            )} /> */}
            <Route path="/campaign/candidate/:id" render={({ match, history }) => (
              <CampaignForm match={match} history={history} />
            )} />
            <Route component={NotFound} />
          </Switch>
        </MuiThemeProvider>
      </ThemeProvider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js